import { render, staticRenderFns } from "./AcceptTermAndCondition.vue?vue&type=template&id=6bb2d280&lang=html&"
import script from "./AcceptTermAndCondition.vue?vue&type=script&lang=js&"
export * from "./AcceptTermAndCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports